/**
 * Videocall Credits & XP Handlers
 *
 * Handles token usage credit deduction and XP awarding after each
 * videocall response turn.
 */
const $ = jQuery;

/**
 * Deduct credits based on token usage from the AI response.
 *
 * @param {number}  tokens            Total tokens used
 * @param {object}  ctx
 * @param {function} ctx.updateCredits     Credits display updater
 * @param {function} ctx.handleAjaxError   Error handler
 * @param {function} ctx.useCreditsResponseEvent  Credits response event factory
 * @returns {number} credits deducted
 */
export async function handleTokenUsage(tokens, ctx) {
    const { updateCredits, handleAjaxError, useCreditsResponseEvent } = ctx;

    let creditsUsed = Math.min(5, Math.ceil(tokens / 2000));

    if (creditsUsed <= 0) return 0;

    let params = {
        credits: creditsUsed,
        reason: 'use_credits'
    };

    $.ajax({
        url: growtype_chat_ajax.url,
        type: "post",
        data: {
            action: 'growtype_chat_use_credits',
            params: params,
        }, success: function (response) {
            updateCredits(response.data.existing_credits);
        }, error: function (response) {
            handleAjaxError(response);
        }, complete: function (response) {
            document.dispatchEvent(useCreditsResponseEvent({
                response: response,
                params: params,
            }));
        },
    });

    return creditsUsed;
}

/**
 * Award XP after a videocall response and update the level bar UI.
 *
 * @param {string}   sessionToken       Current session token
 * @param {function} debugLog           Logging function
 * @param {function} handleAjaxError    Error handler
 */
export function handleAwardXp(sessionToken, debugLog, handleAjaxError) {
    if (!sessionToken) return;

    $.ajax({
        url: growtype_chat_ajax.url,
        type: "post",
        data: {
            action: 'growtype_chat_videocall_award_xp',
            session_token: sessionToken,
            nonce: growtype_chat_ajax.nonce,
        }, success: function (response) {
            debugLog("⭐ XP awarded:", response.data.xp_awarded);

            if (response.data && response.data.level_bar_html) {
                var $existing = $('.g-chat-level');
                if ($existing.length) {
                    $existing.replaceWith(response.data.level_bar_html);
                } else {
                    $('.growtype-chat-level-bar-ajax').replaceWith(response.data.level_bar_html);
                }
            }
        }, error: function (response) {
            handleAjaxError(response);
        }
    });
}
